import React from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
const WidgetChat = (props) => {
  const { history, loginId } = props;
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _goQna = () => {
    if (loginId === null || loginId === undefined || loginId === '') {
      toast.warn('로그인 후 이용해 주세요');
    } else {
      history.push('/customer/3');
    }
  };
  return (
    <>
      <div className="widget-container">
        {/* <div className="">
          <div className="widget-title">채팅으로 문의하기</div>
        </div> */}
        <div className="chat-info">
          문의하고 싶은 내용을 입력해주세요.
          <br />
          <br />
          원하시는 답변을 못찾으셨다면 1:1 문의에 글을 남겨주세요 확인 후 빠르게
          답변을 드릴 수 있도록하겠습니다.
          <br />
          <br />
          문의 외에 작품 및 상품 검색, 오늘의 업데이트, 편성표, 등을 확인 할 수
          있습니다. <br />
          <br />
          아래와 같은 명령어를 입력해 보세요.
          <br />
          <br />
          작품 검색해줘, 인기 작품은?, 오늘의 업데이트 알려줘, 매장 정보, 콜라보
          카페, 편성표 보여줘
        </div>
        <div className="prev-chat-container">
          <div className="prev-contaner">
            <div className="prev" onClick={_goQna}>
              <img src="/img/chatbot/icon_qna.png" />
              고객 센터로 이동하기
            </div>

            <div onClick={_goHome} className="prev">
              <img src="/img/chatbot/icon_home.png" />
              처음으로
            </div>
          </div>
        </div>
      </div>
      <div className="widget-time">{props.childProps.payload.writetime}</div>
    </>
  );
};
export default shopContext(withRouter(WidgetChat));
